import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'pt-translate-service-renderer',
  template: `
    <span *ngIf="value">
     {{value | translate}}
    </span>
  `
})
export class TranslateServiceRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  params: any;
  value: any;
  agInit(params: any): void {
    this.params = params;
    this.value = this.params && this.params.value && this.params.value.length > 3 ? this.params.value : undefined;

  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
